import React from 'react';
import geostats from 'geostats';

function useHexDataManager() {
  const hexBins = React.useRef([]);

  const computeNewThreatScore = (slugs, properties) => {
    if (!properties) {
      return;
    }
    const howMany = slugs.length - 1;  // we subtract 1 because we don't want to include the whp score in the average portion of the threat calculation.

    const whp = isNaN(properties.whp_idx) ? 0 : properties.whp_idx;
    let nonWhpThreatScore = 0;
    if (slugs.includes('Pp')) {
      nonWhpThreatScore += properties.normPpScore;
    }
    if (slugs.includes('Dw')) {
      nonWhpThreatScore += properties.normDwScore;
    }
    if (slugs.includes('Cult')) {
      nonWhpThreatScore += properties.normCultScore;
    }
    if (slugs.includes('Infra')) {
      nonWhpThreatScore += properties.normInfraScore;
    }
    if (slugs.includes('Wl')) {
      nonWhpThreatScore += properties.normWlScore;
    }
    const threatScore = howMany === 0 ? whp : whp * ((nonWhpThreatScore / howMany));
    const threatScoreSafe = isNaN(threatScore) ? 0 : threatScore;
    properties.threat = threatScoreSafe;
    return threatScoreSafe;
  }

  const determineNewBin = (threatVal, intervals) => {
    let res = 0;

    for(let i = 0; i < intervals.length - 1; i++) {
      const second = i === intervals.length - 2 ? threatVal <= intervals[i+1] : threatVal < intervals[i+1]      

      if(threatVal >= intervals[i] && second) {
        res = i+1;
        break;
      }
    }
    return res;
  }


  const computeNewHexBins = (threatScoresToBin) => {
    if (!threatScoresToBin || threatScoresToBin.length === 0) {
      return [];
    }
    // The jenks routine will fail if you ask for say 5 bins but your dataset
    // contains less than 5 distinct values.
    const uniqueThreatScores = [...new Set(threatScoresToBin)];
    if (uniqueThreatScores.length === 1) {
      return [];
    }
    const howManyBuckets = Math.min(uniqueThreatScores.length, 5);
    const gs = new geostats(threatScoresToBin);
    return gs.getClassJenks(howManyBuckets);
  }

  return {
    hexBins,
    computeNewThreatScore,
    determineNewBin,
    computeNewHexBins
  };
}

export default useHexDataManager;